import { render, staticRenderFns } from "./singlecontent.vue?vue&type=template&id=47c4ef5a&scoped=true"
import script from "./singlecontent.vue?vue&type=script&lang=js"
export * from "./singlecontent.vue?vue&type=script&lang=js"
import style0 from "./singlecontent.vue?vue&type=style&index=0&id=47c4ef5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4ef5a",
  null
  
)

export default component.exports